import { mainPath } from "../../../constants/access";

const nameTable = "users";
const tPath = `${mainPath}.${nameTable}`;

export default tPath;
